/* eslint-disable max-lines */
import { css } from 'linaria';

export const signSection = css`
  padding: 80px 0;
  background-color: var(--control-primary);

  @media (--only-tablet) {
    padding: 64px 0;
  }

  @media (--only-mobile) {
    padding: 40px 0;
    border-radius: 12px 12px 0 0;
  }
`;

export const signSectionContainer = css`
  display: flex;
  column-gap: 24px;

  @media (--to-desktop) {
    flex-direction: column;
    column-gap: 0;
    row-gap: 64px;
  }

  @media (--only-mobile) {
    row-gap: 40px;
  }
`;

export const signSectionAddContentContainer = css`
  margin-top: 40px;
  width: 100%;

  @media (--only-desktop) {
    margin-top: 32px;
  }

  @media (--to-desktop) {
    margin-top: 64px;
  }

  @media (--only-mobile) {
    margin-top: 24px;
  }
`;

export const signSectionBlockWrapper = css`
  width: 578px;

  @media (--only-desktop) {
    width: 458px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const signSectionBlockTextWrapper = css`
  && {
    width: 500px;

    @media (--to-desktop) {
      width: 414px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

export const signSectionTitle = css`
  && {
    margin-bottom: 8px;
  }
`;

export const signSectionSubtitle = css`
  && {
    width: 456px;
    margin-bottom: 24px;

    @media (--to-desktop) {
      width: 100%;
    }

    @media (--from-tablet) and (--to-largeDesktop){
      white-space: break-spaces;
    }
  }
`;

export const signSectionStoreGrid = css`
  display: grid;
  grid-template-columns: 145px 421px;
  grid-template-rows: 145px 145px;
  column-gap: 12px;
  row-gap: 12px;

  @media (--only-desktop) {
    grid-template-columns: 112px 334px;
    grid-template-rows: 112px 112px;
  }

  @media (--only-tablet) {
    grid-template-columns: 146px 502px;
    grid-template-rows: 146px 146px;
  }

  @media (--only-mobile) {
    grid-template-columns: 22.2vw 65.3vw;
    grid-template-rows: 22.2vw 22.2vw;
    column-gap: 2.5vw;
    row-gap: 2.5vw;
  }

  & button:nth-of-type(2) {
    grid-row-start: span 2;
  }
`;

export const signSectionStoreItem = css`
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: var(--rounding-m);
  cursor: pointer;
`;

export const signSectionStoreImage = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--rounding-m);
`;

export const signSectionPointsWrapper = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 32px;
  margin-top: 16px;
  background-color: rgb(255 255 255 / 10%);
  border-radius: var(--rounding-m);

  @media (--only-desktop) {
    padding: 0 20px;
  }

  @media (--only-mobile) {
    justify-content: center;
    padding: 0 12px;
    margin-top: 8px;
    column-gap: 21px;
  }
`;

export const signSectionPointsOnlineWrapper = css`
  padding: 0 60px;

  @media (--only-desktop) {
    padding: 0 36px;
  }

  @media (--only-tablet) {
    padding: 0 76px;
  }

  @media (--only-mobile) {
    padding: 0 16px;
  }
`;

export const signSectionPoint = css`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  column-gap: 12px;

  @media (--only-desktop) {
    && p {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (--only-mobile) {
    padding: 10px 0;
    column-gap: 4px;

    && > div:first-child {
      width: 16px;
      height: 16px;
    }

    && p {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const signSectionOnlineImage = css`
  display: block;
  width: 578px;
  height: 302px;
  object-fit: contain;

  @media (--only-desktop) {
    width: 458px;
    height: 236px;
  }

  @media (--only-tablet) {
    width: 660px;
    height: 303px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 51.5vw;
  }
`;
